import { Skeleton } from '@ethings/ui-toolkit';
import { isNumber } from 'lodash';
import { FC } from 'react';
import { useLocationWeatherQuery } from '../../hooks';
import { mapWeatherIcon } from '../../util';
import { Icon } from '../icons';

interface Props {
  'data-testid'?: string;
  latLng: L.LatLng;
}

export const CurrentWeatherIcon: FC<Props> = ({ latLng, ...props }) => {
  const { isLoading, data: weather } = useLocationWeatherQuery({ latLng });

  if (isLoading) {
    return <span style={{ display: 'inline-block' }}><Skeleton variant='circular' width='1em' height='1em' /></span>;
  }

  const iconId = (weather && isNumber(weather.iconId)) ? weather.iconId : 0;
  const icon = mapWeatherIcon(iconId);

  return <Icon data-testid={props['data-testid']} icon={icon} />;
};
